import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';

export interface Payload {
  folderId: string;
  currentName: string;
}

const payloadAtom = atom<Payload | undefined>(undefined);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
export const useIsOpenRenameFolderModal = () => useAtomValue(isOpenAtom);

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, undefined));
export const useCloseRenameFolderModal = () => useSetAtom(closeModalAtom);

export const useOpenRenameFolderModal = () => useSetAtom(payloadAtom);

export const useGetRenameFolderModalPayload = () => useAtomValue(payloadAtom);
